import React from 'react';
import './Footer.css'
import {BsInstagram,BsFacebook,BsTwitter,BsWhatsapp,BsLinkedin} from 'react-icons/bs'
import {Link} from 'react-router-dom'

function Footer() {
  let year = new Date().getFullYear();

  return (
    <div className='footer'>
      <div className='footer-content'>
        <div className='container1'>
          <div>
            <div style={{fontSize:'3vh'}}> HOW WE HELP </div>
            <>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/hiring-and-selection'>Hiring and Selection</Link></div> 
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/training-and-development'>Training and Development</Link></div> 
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/leadership-identification'>Leadership Identification</Link></div> 
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/team-building'>Team Building and Analytics</Link></div> 
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/culture-and-values'>Culture and Values</Link></div> 
            </>
          </div>

          <div style={{marginLeft:'3vw'}}>
            <div style={{fontSize:'3vh'}}> ASSESSMENT CORNER </div>
            <>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/pratibimb'>Pratibimb (PAVE)</Link></div>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/work-value-attitude'>Work Values and Attitude</Link></div> 
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/work-style-performance'>Work Style and Performance Profile</Link></div> 
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/cognitive-quotient'>Cognitive Quotient</Link></div> 
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/leadership-profile'>Leadership Profile</Link></div> 
            </>
          </div>

          {/* <div style={{marginLeft:'3vw'}}>
            <div style={{fontSize:'3vh'}}> ABOUT US </div>
            <>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/founder'>Our Founder</Link></div>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/scientific-advisors'>Scientific Advisors</Link></div>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/mission-vision-values'>Mission, Vision and Values</Link></div>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/faqs'>FAQs</Link></div>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/careers'>Careers</Link></div>
              <div style={{margin:'2vh 0'}}><Link className='footer-links' to='/contact'>Contact Us</Link></div>
            </>
          </div> */}
      </div>

        <div className='container2'>
          <div className='footer-heading'>STRATEGIC LINKS</div>
          <div>Reach out to us: contactus@strategiclinks.in</div>
          <div style={{marginTop:'5vh'}}>
            B3502, DB Woods, CHS Krishna Vatika Marg, <br/>
            Goregaon(East), Mumbai, 400063, Maharashtra, INDIA
          </div>
          <div className='social-media-container'>
              <a href='https://www.instagram.com/strategiclinks.in/'><BsInstagram className='social-media-icon'/></a>
              <a href='https://www.facebook.com/profile.php?id=100077341645542'><BsFacebook className='social-media-icon'/></a>
              <a href='https://twitter.com/LinksStrategic'><BsTwitter className='social-media-icon'/></a>
              <a href="https://wa.me/+918779129511?text=Hello"><BsWhatsapp className='social-media-icon'/></a>
              <a href='https://www.linkedin.com/company/strategiclinksin/'><BsLinkedin className='social-media-icon'/></a>
          </div>
          <div style={{color:'rgba(255,255,255,.68)'}}>© {year} Strategic Links</div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
